import axios from "axios";

export default axios.create({
  baseURL: "Company_Url_removed",
});
